import {
    Button,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Skeleton,
    Table,
    TableBody,
    TableCell,
    TableRow,
    TableContainer,
} from '@mui/material'
import { useTranslation } from 'react-i18next'
import { SingleLineTextInputSkeleton } from '@/components/SingleLineTextInputSkeleton'

const seleniumPrefix = 'user-create-or-edit-pending-component'

export const UserCreateOrEditPendingComponent: React.FC<{ title: string }> = ({
    title,
}) => {
    const { t } = useTranslation()

    return (
        <Card>
            <CardHeader title={title} />
            <CardContent>
                <SingleLineTextInputSkeleton />
                <SingleLineTextInputSkeleton />
                <SingleLineTextInputSkeleton />
                <SingleLineTextInputSkeleton />
                <SingleLineTextInputSkeleton />
                <SingleLineTextInputSkeleton />
                <SingleLineTextInputSkeleton />
                <SingleLineTextInputSkeleton />
                <SingleLineTextInputSkeleton />

                <TableContainer>
                    <Table>
                        <TableBody>
                            <TableRow>
                                <TableCell style={{ width: '33.33%' }}>
                                    <Skeleton />
                                </TableCell>
                                <TableCell style={{ width: '33.33%' }}>
                                    <Skeleton />
                                </TableCell>
                                <TableCell style={{ width: '33.33%' }}>
                                    <Skeleton />
                                </TableCell>
                                <TableCell />
                            </TableRow>
                            <TableRow>
                                <TableCell style={{ width: '33.33%' }}>
                                    <Skeleton />
                                </TableCell>
                                <TableCell style={{ width: '33.33%' }}>
                                    <Skeleton />
                                </TableCell>
                                <TableCell style={{ width: '33.33%' }}>
                                    <Skeleton />
                                </TableCell>
                                <TableCell>
                                    <Skeleton
                                        variant={'circular'}
                                        height={34}
                                        width={34}
                                    />
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </CardContent>

            <CardActions style={{ justifyContent: 'flex-end' }}>
                <Button
                    disabled={true}
                    data-selenium={`${seleniumPrefix}-back`}
                >
                    {t('common.back')}
                </Button>
                <Button
                    variant={'outlined'}
                    disabled={true}
                    data-selenium={`${seleniumPrefix}-save`}
                >
                    {t('common.save')}
                </Button>
            </CardActions>
        </Card>
    )
}
